"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'polyfill';
// global.Promise = require('es6-promise').Promise;
// import 'picturefill';
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
require("swipe-elem");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
var page2top_1 = __importDefault(require("page2top"));
// import '@fancyapps/fancybox';
// import 'fancy-defaults';
var nav_current_1 = __importDefault(require("nav-current"));
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var menu_1 = require("menu");
var search_1 = require("search");
(0, hasher_1.default)();
$(function () {
    new linker_1.default();
    new menu_1.Menu();
    new nav_current_1.default('.l-global', {
        abs: true
    });
    new page2top_1.default();
    (0, tel_handler_1.default)();
    (0, slide_scroll_1.default)({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.u-not-scroll, .u-modal'
    });
    new search_1.areaSearch();
    new search_1.locationSearch();
    new search_1.searchResult();
    $('.sw-Swipe').swipeElem({
        width: 700
    });
    if ($('#topHeroSlider').length) {
        $('#topHeroSlider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            fade: true,
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1000,
            autoplaySpeed: 4000,
            autoplay: true
        });
        (0, object_fit_images_1.default)('.tp-hero__slider__item img, .c-header__img', { watchMQ: true });
    }
    ;
    (0, object_fit_images_1.default)('img.sw-ObjectFit', { watchMQ: true });
});
